import { Component, input, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IPaymentMethod } from '@core/interface';
import { PaymentStatusEnum } from '@core/enums';
import { DialogComponent, ButtonLibComponent } from '@components/atoms';
import { PAYMENT_ASSETS_PATH, PAYMENT_STATUS_CONFIG } from './status-payment.constants';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-ui-status-payment',
  standalone: true,
  imports: [CommonModule, TranslateModule, DialogComponent, ButtonLibComponent],
  templateUrl: './status-payment.component.html',
  styleUrls: ['./status-payment.component.scss'],
})
export class StatusPaymentComponent implements OnInit {
  private readonly translate = inject(TranslateService);

  paymentDTO = input.required<IPaymentMethod>();
  showModal = input<boolean>(false);
  alignCenter = input<boolean>(false);
  showPaymentID = input<boolean>(false);
  label = signal<string>('');

  img = '';
  openModal = false;

  ngOnInit(): void {
    this.initData();
  }

  initData() {
    const normalizedStatus = this.normalizeStatus(this.paymentDTO().status);
    this.img = this.resolveIcon(normalizedStatus);
    this.resolveLabel(normalizedStatus);
  }

  private normalizeStatus(status: string | null | undefined): PaymentStatusEnum {
    const normalized = (status ?? '').trim().toLowerCase() as PaymentStatusEnum;
    return Object.values(PaymentStatusEnum).includes(normalized) ? normalized : PaymentStatusEnum.PENDING;
  }

  private resolveIcon(status: PaymentStatusEnum): string {
    return PAYMENT_STATUS_CONFIG[status]?.icon ?? `${PAYMENT_ASSETS_PATH}/pending-icon.svg`;
  }

  private resolveLabel(status: PaymentStatusEnum): void {
    const textKey = PAYMENT_STATUS_CONFIG[status]?.textKey ?? 'payment-methods.status.pending';
    let labelText = this.translate.instant(textKey);

    const statusesWithPaymentId = [
      PaymentStatusEnum.APPROVED,
      PaymentStatusEnum.REFUNDED,
      PaymentStatusEnum.CHARGED_BACK,
      PaymentStatusEnum.AUTHORIZED,
    ];
    if (statusesWithPaymentId.includes(status) && this.showPaymentID() && this.paymentDTO().paymentId) {
      labelText = `${labelText} \u2013 ${this.paymentDTO().paymentId}`;
    }

    this.label.set(labelText);
  }
}
